import { LoadingWolf, VStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useScannerDetails } from '@apis/rendall/queries/use-scanner-details/use-scanner-details';

import { scannerDetailSelect } from '../../../../hooks/use-enhanced-scanner-details/use-enhanced-scanner-details';

import { HostDnsServersForm } from './host-dns-servers-form';

const HostDnsServerPage: React.FC = () => {
  const { scannerId = '' } = useParams();
  const { t } = useTranslation('ui');

  const { data: scannerDetails, isPending } = useScannerDetails(scannerId, {
    select: scannerDetailSelect,
  });

  return isPending || !scannerDetails ? (
    <VStack width="full" xAlign="center" style={{ height: '60vh' }}>
      <LoadingWolf isLoading caption={t('loader.caption')} />
    </VStack>
  ) : (
    <HostDnsServersForm scannerDetails={scannerDetails} />
  );
};

export default HostDnsServerPage;

export const Component = () => <HostDnsServerPage />;
